import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const addCreateSurveysStatusSelector = (state: State) =>
  state.createSurveys.status;
export const addCreateSurveysIdSelector = (state: State) =>
  state.createSurveys.entities?.id;
export const addCreateSurveysLoadedSelector = isLoaded(
  addCreateSurveysStatusSelector,
);
export const shouldLoadaddCreateSurveysSelector = shouldLoad(
  addCreateSurveysStatusSelector,
);
export const addCreateSurveysRejectedSelector = isRejected(
  addCreateSurveysStatusSelector,
);
export const addCreateSurveysPendingSelector = isPending(
  addCreateSurveysStatusSelector,
);
